import { api } from '../utils/axiosInstance'
import { getUserLanguage } from '../utils/localStorage'

export const fetchAvailableConsentsApi = async (params = {}) => {
  const language = params.language || getUserLanguage() || 'en'
  const platform = params.platform || 'web'
  const { headers: customHeaders, ...restParams } = params

  const response = await api.get('/v1/consents/available', {
    params: {
      platform,
      language,
      country: 'IN',
      ...restParams
    },
    headers: {
      ...(customHeaders || {})
    }
  })
  if (response?.data && response.data.success === false) {
    throw new Error(response.data.message || 'Failed to fetch available consents')
  }
  return response.data
}


export const fetchConsentHistoryApi = async (options = {}) => {
  const headers = {}
  if (options.token) {
    headers['x-api-token'] = options.token
  }
  const response = await api.get('/v1/consents/history', {
    headers: {
      ...headers,
      ...(options.headers || {})
    }
  })
  if (response?.data && response.data.success === false) {
    throw new Error(response.data.message || 'Failed to fetch consent history')
  }
  return response.data
}


export const saveConsentApi = async (data = {}) => {
  const { headers: customHeaders, ...restData } = data
  const payload = {
    platform: 'web',
    consent_version: '1.0',
    ...restData
  }
  const response = await api.post('/v1/consents/save-consents', payload, {
    headers: {
      'Content-Type': 'application/json',
      ...(customHeaders || {})
    }
  })
  if (response?.data && response.data.success === false) {
    throw new Error(response.data.message || 'Failed to save consent')
  }
  return response.data
}


export const revokeConsentApi = async (data = {}) => {
  if (!data?.consent_id) {
    throw new Error('consent_id is required to revoke consent')
  }
  const { headers: customHeaders, ...restData } = data
  const response = await api.post(
    '/v1/consents/revoke',
    { consent_id: restData.consent_id },
    {
      headers: {
        'Content-Type': 'application/json',
        ...(customHeaders || {})
      }
    }
  )
  if (response?.data && response.data.success === false) {
    throw new Error(response.data.message || 'Failed to revoke consent')
  }
  return response.data
}


export const fetchConsentDetailsApi = async (scope, options = {}) => {
  if (!scope) return null
  const { headers: customHeaders, ...restParams } = options
  const response = await api.get('/v1/consents/details', {
    params: {
      scope,
      ...restParams
    },
    headers: {
      ...(customHeaders || {})
    }
  })
  if (response?.data && response.data.success === false) {
    throw new Error(response.data.message || 'Failed to fetch consent details')
  }
  return response.data?.data || response.data
}
